import { invokeOrFalse } from '.';
export default function callRefFunc(ctx, refName, funcName, arg1, arg2, arg3) {
    const ref = ctx.$refs[refName];
    if (!ref) {
        // console.info(`ref is not found for refName ${refName} argument of callRefFunc function`)
        return void 0;
    }
    let refComponent;
    if (Array.isArray(ref)) {
        refComponent = ref[0] || {};
    }
    else if (ref) {
        refComponent = ref;
    }
    else {
        refComponent = {};
    }
    invokeOrFalse(refComponent[funcName], arg1, arg2, arg3); // add more args if needed
}
